export default __webpack_public_path__ + "static/media/Chewing Tobacco.75d8218a.png";